module.exports = __webpack_public_path__ + "img/Apifox.a192d13a.png";